import type { ReactElement, SVGProps } from "react";

export function IneligibleLock(props: SVGProps<SVGSVGElement>): ReactElement {
  const { fill = "#949ABF", ...restProps } = props;

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M4.34365 14.7344C3.91409 14.7344 3.55498 14.59 3.26631 14.3014C2.97765 14.0127 2.83331 13.6536 2.83331 13.224V7.24471C2.83331 6.81515 2.97765 6.45604 3.26631 6.16738C3.55498 5.87871 3.91409 5.73438 4.34365 5.73438H4.86665V4.40104C4.86665 3.51382 5.17092 2.76426 5.77948 2.15238C6.38792 1.54038 7.12809 1.23438 7.99998 1.23438C8.87187 1.23438 9.61204 1.54038 10.2205 2.15238C10.829 2.76426 11.1333 3.51382 11.1333 4.40104V5.73438H11.6563C12.0859 5.73438 12.445 5.87871 12.7336 6.16738C13.0223 6.45604 13.1666 6.81515 13.1666 7.24471V13.224C13.1666 13.6536 13.0223 14.0127 12.7336 14.3014C12.445 14.59 12.0859 14.7344 11.6563 14.7344H4.34365ZM8.00265 11.501C8.34876 11.501 8.64037 11.3815 8.87748 11.1425C9.1147 10.9037 9.23331 10.6112 9.23331 10.265C9.23331 9.91893 9.11381 9.62732 8.87481 9.39021C8.63592 9.15299 8.34342 9.03438 7.99731 9.03438C7.6512 9.03438 7.35959 9.15388 7.12248 9.39288C6.88526 9.63176 6.76665 9.92426 6.76665 10.2704C6.76665 10.6165 6.88615 10.9081 7.12515 11.1452C7.36404 11.3824 7.65654 11.501 8.00265 11.501ZM5.96665 5.73438H10.0333V4.40104C10.0333 3.83438 9.83542 3.34826 9.43965 2.94271C9.04387 2.53715 8.56331 2.33438 7.99798 2.33438C7.43265 2.33438 6.95276 2.53715 6.55831 2.94271C6.16387 3.34826 5.96665 3.83438 5.96665 4.40104V5.73438Z"
        fill={fill}
      />
    </svg>
  );
}
